import React from 'react'

// TODO: implement
function DateInput() {
  return <>Date Input</>
}

export default DateInput
